const textareaTrackingClass = '__CURSOR_TEXTAREA'
const listSiblingTrackingClass = '__CURSOR_LIST_SIBLING'

const textareaSelector = '.' + textareaTrackingClass
const listSiblingSelector = '.' + listSiblingTrackingClass

function findListSibling(target: HTMLElement): HTMLElement {
  const sibling = target.closest<HTMLElement>(listSiblingSelector)
  if (sibling) {
    return sibling
  }

  throw new Error(`
Can't find list sibling. 
Make sure that you added tracking class on EACH direct list child (ul > li).
DON'T WRAP element with tracking class! It will break everything
Example: 
   <ul> 
       <li class="TRACKING_CLASS">1</li> 
       <li class="TRACKING_CLASS">2</li> 
       <li class="TRACKING_CLASS">3</li> 
   </ul>
    `)
}

function findNextTextarea(target): HTMLInputElement | null | undefined {
  return findListSibling(target).nextElementSibling?.querySelector(
    textareaSelector
  )
}
function findPreviousTextarea(target): HTMLInputElement | null | undefined {
  return findListSibling(target).previousElementSibling?.querySelector(
    textareaSelector
  )
}

export function useCursorMover() {
  function handleArrowLeft(event) {
    const target: HTMLInputElement = event.target
    if (target.selectionStart !== 0) {
      return //We want trigger only at the start of text
    }

    const prevTextarea = findPreviousTextarea(target)
    if (!prevTextarea) {
      return //This is first textarea in list
    }

    const cursorPosition = prevTextarea.value.length
    event.preventDefault()
    prevTextarea.focus()
    prevTextarea.setSelectionRange(cursorPosition, cursorPosition)
  }

  function handleArrowRight(event) {
    const target: HTMLInputElement = event.target
    if (target.selectionStart !== target.value.length) {
      return //We want trigger only at the end of text
    }

    const nextTextarea = findNextTextarea(target)
    if (!nextTextarea) {
      return //This is last textarea in list
    }

    event.preventDefault()
    nextTextarea.focus()
    nextTextarea.setSelectionRange(0, 0)
  }

  return {
    handleArrowLeft,
    handleArrowRight,
    textareaTrackingClass,
    listSiblingTrackingClass
  }
}
